import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  updateLeadCounts,
  updateLeadPondsCounts,
  updatePeopleCounts,
  updateTaskCounts,
  updateTransactionCounts,
} from "../../../reducers/layoutReducer";

const PROMISE_CACHE = {};

// milliseconds * seconds * minutes
const MINUTES_5 = 1000 * 60 * 5;

const TYPES = {
  Leads: { action: updateLeadCounts, url: "/leads_counts" },
  "Lead Ponds": { action: updateLeadPondsCounts, url: "/leads_counts/lead_ponds" },
  People: { action: updatePeopleCounts, url: "/people_counts" },
  Tasks: { action: updateTaskCounts, url: "/tasks/counts" },
  Transactions: { action: updateTransactionCounts, url: "/listings/counts" },
};

const shouldUpdate = (counts) =>
  typeof counts?.lastUpdate === "undefined" || Date.now() - counts.lastUpdate > MINUTES_5;

const useCounts = (type, shouldFetchCounts = true) => {
  const counts = useSelector(({ layout }) => layout.counts?.[type]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!shouldFetchCounts || !TYPES[type]) return;
    const { action, url } = TYPES[type];
    // in the unlikely event that the page hasn't refreshed within 5 minutes
    // cache the sidebar counts for that amount of time before updating
    // TODO: provide dynamic way to update counts as things are changed
    if (shouldUpdate(counts) && !PROMISE_CACHE[url]) {
      PROMISE_CACHE[url] = axios.get(url).then(({ data }) => {
        dispatch(action(data));
        PROMISE_CACHE[url] = null;
      });
    }
  }, [counts, type, shouldFetchCounts]);

  return { counts };
};

export default useCounts;
